import React from 'react'
import './footer2.css'
import footer1 from '../../assets/images/OLDMUTUALTEXT.svg'

function Footer3() {
  return (
        <>
            <div className='om-ribbon-bottom'>
                OLD<span style={{fontWeight:'600'}}>MUTUAL</span>
            </div>
           
        </>
  )
}

export default Footer3
